export default {
  pageName: 'AI Preview',
  pageId: '25084',
  pagePath: '/opinion/AIAnalysisHub/KeywordAnalysis/preview',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    PreviewAnalysis: {
      buttonId: '2508401',
    },
    SearchAnalysis: {
      buttonId: '2508402',
    },
    DownloadAnalysis: {
      buttonId: '2508403',
    },
    DeleteAnalysis: {
      buttonId: '2508404',
    },
    GPT_Confirm: {
      buttonId: '2508409',
    },
  },
  card: {
    GPT: {
      refresh: {
        buttonId: '2508405',
      },
      copy: {
        buttonId: '2508406',
      },
      fullscreen: {
        buttonId: '2508407',
      },
    },
    ChartCard: {
      bar: {
        buttonId: '2508408',
      },
      line: {
        buttonId: '2508410',
      },
      pie: {
        buttonId: '2508411',
      },
      table: {
        buttonId: '2508412',
      },
      'sentiment-s-bar': {
        buttonId: '2508413',
      },
      'common-bar': {
        buttonId: '2508414',
      },
      stack_line: {
        buttonId: '2508415',
      },
      download: {
        buttonId: '2508416',
      },
    },
  },
};
